// api.ts
import { BASE_URL } from "../scripts/base";

/**PDATA - последний параметр всегда is_single (True/False)!!! - характеризующий о
* том, будет возвращены записи или только одна запись
**/

export interface BurialCardType {
    burial_address: string
    burial_length: number
    burial_number: string
    burial_row: string
    burial_type_id: number
    burial_type_name: string
    burial_width: number
    card_id: number
    card_name: string
    cemetery_id: number
    cemetery_name: string
    coordinates: number[]
    coordinate_source_id: number
    coordinates_json: CoordinateJsonType
    dead_list: DeadListBurialType[]
    description: string
    id: number
    is_numberless: boolean
    region_full_name: string
    region_id: number
    region_name: string
}

export interface CoordinateJsonType {
    coordinates: Array<number[]> | number[]
    type: 'Polygon' | 'Point'
}


interface DeadListBurialType {
    date_burial: string
    date_life: string
    fio: string
    id: number
    responsible_address: string
    responsible_fio: string
    responsible_phone: string
}

export interface GuidListType {
    guid_filename: string
    id: number
}


/** Получение списка захоронений карты */
export const BURIAL_PDATA = (params: any) => {
    return BASE_URL.get<BurialCardType[]>('/pdata/pd_burial/', {
        params,

    })
}

export interface CemeteryType {
    cards: []
    cemetery_address: string
    cemetery_coordinates: Object
    cemetery_id: number
    guid: string
    cemetery_name: string
    municipality_id: number
    municipality_name: string
    municipality_path: Object
    access_revoked?: boolean
}

export interface CemeteryLoadResponseType {
  info_json: CemeteryType[]
}

export const LOADS_CEMETERY = (params?: any) => {
    return BASE_URL.get<CemeteryLoadResponseType[]>('/loads/cemetery/', {
        params,
    })
}

export const GET_LOADS_BURIALS = (params: any) => {
    return BASE_URL.get('/loads/burials/', {
        params,
    })
}

export const GET_LOADS_POINTS = (params: any) => {
    return BASE_URL.get('/loads/points/', {
        params,
    })
}


export const LOADS_POINTS = (params?: any) => {
    return BASE_URL.post('/loads/load/', params)
}


export const LOADS_PHOTO = (params?: any) => {
    return BASE_URL.get('/loads/photo/', { params })
}

export const LOADS_PHOTO_CNT = (params?: any) => {
    return BASE_URL.get('/loads/photo_cnt/', { params })
}

export const UPLOAD_PHOTO = (params?: any) => {
    return BASE_URL.post('/loads/photo/', params )
}
